// Components/RateTypeData.jsx
export const rateTypeColumns = [
  { Header: "S.No", accessor: "sno" },
  { Header: "Name", accessor: "name" },
  { Header: "Room Type", accessor: "room_type" },
  { Header: "Base Price", accessor: "base_price" },
  { Header: "Status", accessor: "is_active" },
  { Header: "Actions", accessor: "actions" },
];
